export enum AddressRoles {
  MANAGER = 'roles.addressManager',
}
